import React from 'react'
import styled from 'styled-components/macro'

import HeroImageSvg from 'assets/hero-image.svg'
import AddressSearch from 'components/AddressSearch'

type Props = {
  className?: String
}

const LandingHero = ({className}: Props) => {
  return (
    <LandingHero.Styled className='hero-section'>
      <section className='hero-address-section'>
        <h1>Enter an address to begin.</h1>
        <p>Learn the current market value of a property and more.</p>
        <AddressSearch />
      </section>
      <section className='hero-image-section'>
        <img src={HeroImageSvg} alt='Project Portal Hero Graphic of House' />
      </section>
    </LandingHero.Styled>
  )
}

LandingHero.Styled = styled.div`
  display: flex;
  width: 100vw;
  height: 600px;
  padding: 0 40px;
  justify-content: center;
  background: linear-gradient(
    179.29deg,
    ${({theme}) => theme.colors.gold.light} 4.76%,
    ${({theme}) => theme.colors.gold.base} 161.07%
  );
  .hero-address-section,
  .hero-image-section {
    max-width: 640px;
    display: flex;
    flex-direction: column;
  }
  .hero-address-section {
    min-width: 580px;
    align-items: flex-start;
    display: flex;
    justify-content: center;

    h1 {
      margin-bottom: 17px;
    }
    p {
      margin: 25px 0;
    }
    h1 + p {
      margin-top: 0px;
    }
  }
  .hero-image-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 100%;
      height: auto;
    }
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    height: 700px;

    .hero-address-section,
    .hero-image-section {
      width: 90%;
      max-width: 590px;
      min-width: 0;
    }

    .hero-address-section {
      align-items: center;
    }
  }
`

export default LandingHero
